import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
  required,
  maxLength,
  integer,
  minValue
} from "vuelidate/lib/validators";
import axios from "axios";

export default {
  name: "ItemCreate",
  components: {
    MainLayout,
  },

  data() {
    return {
      itemData: {
        p_item_name: null,
        p_item_amount: null,
      },
      submitted: false,
      disabled: false,
      itemExists: false,
    };
  },

  validations: {
    itemData: {
      p_item_name: {
        required,
        maxLength: maxLength(100)
      },
      p_item_amount: {
        required,
        integer,
        maxLength: maxLength(9),
        minValue: minValue(1)
      },
    },
  },

  methods: {
    async checkDuplicateItem() {
        try {
            const response = await axios.get("/item/checkDuplicateItem", {
                params: {
                    item_name: this.itemData.p_item_name,
                },
            });
            this.itemExists = response.data.exists;
            this.submitted = false;
            this.disabled = false;
        } catch (error) {
            console.error('An error occurred:', error);
        }
    },

    async confirmRegister() {
      if (this.disabled) return;
      this.submitted = true;
      this.disabled = true;
      await this.checkDuplicateItem();
      if(this.itemExists){
        this.$notification.error("Payment Item Name is already exist.", {
            timer: 3,
            position: "bottomCenter"
          });
        return;
      }
      this.create();
  },

    create() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      this.disabled = true;
      this.isLoading = false;
      this.itemData.loginID = this.$store.state.user.id;
      axios.post('item/create', this.itemData)
        .then(res => {
          this.disabled = false;
          if (res.data.success === true) {
            this.$notification.success("Item Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'itemList'
            })
          } else {
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter"
            })
          }
        }).catch(error => {
          this.disabled = false;
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    }
  },

  mounted() {
  },
};
